import {
  CLEAR_CANCEL_ORDER_ERROR,
  CLEAR_CANCEL_ORDER_STATE,
  CLEAR_INVOICE_DOWNLOAD_ERRORS,
  CLEAR_ORDER_ERRORS,
  CLEAR_ORDER_PAYMENT_ERRORS,
  CLEAR_ORDER_PAYMENT_STATE,
  CLEAR_ORDER_STATE,
  CLEAR_UPDATE_ORDER_ERRORS,
  CLEAR_UPDATE_ORDER_STATE,
  GET_ORDER_INVOICE_FAIL,
  GET_ORDER_INVOICE_REQUEST,
  GET_ORDER_INVOICE_SUCCESS,
  GET_ORDER_LIST_FAIL,
  GET_ORDER_LIST_REQUEST,
  GET_ORDER_LIST_SUCCESS,
  ORDER_CANCEL_FAIL,
  ORDER_CANCEL_REQUEST,
  ORDER_CANCEL_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_PAYMENT_FAIL,
  ORDER_PAYMENT_REQUEST,
  ORDER_PAYMENT_SUCCESS,
  UPDATE_ORDER_ADDRESS_FAIL,
  UPDATE_ORDER_ADDRESS_REQUEST,
  UPDATE_ORDER_ADDRESS_SUCCESS,
} from "../constant/orderConstant";

export const createNewOrderReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CREATE_REQUEST:
      return {
        loading: true,
        orderData: {},
      };
    case ORDER_CREATE_SUCCESS:
      return {
        loading: false,
        orderData: action.payload,
      };
    case ORDER_CREATE_FAIL:
      return {
        loading: true,
        error: action.payload,
      };

    case CLEAR_ORDER_ERRORS:
      return {
        orderData: {},
        loading: false,
        error: null,
      };
    case CLEAR_ORDER_STATE:
      return {
        orderData: null,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};


// CANCEL ORDER REDUCER STARTS 
export const orderCancelReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CANCEL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ORDER_CANCEL_SUCCESS:
      return {
        loading: false,
        cancelOrderInfo: action.payload,
      };
    case ORDER_CANCEL_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case CLEAR_CANCEL_ORDER_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case CLEAR_CANCEL_ORDER_STATE:
      return {
        loading: false,
        cancelOrderInfo: null,
      };

    default:
      return state;
  }
};

export const createOrderPaymentReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_PAYMENT_REQUEST:
      return {
        loading: true,
        paymentInfo: {},
      };
    case ORDER_PAYMENT_SUCCESS:
      return {
        loading: false,
        paymentInfo: action.payload,
      };
    case ORDER_PAYMENT_FAIL:
      return {
        loading: true,
        error: action.payload,
      };

    case CLEAR_ORDER_PAYMENT_ERRORS:
      return {
        paymentInfo: {},
        loading: false,
        error: null,
      };
    case CLEAR_ORDER_PAYMENT_STATE:
      return {
        paymentInfo: null,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};


export const updateOrderAddressReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_ORDER_ADDRESS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_ORDER_ADDRESS_SUCCESS:
      return {
        loading: false,
        shipInfo: action.payload,
      };
    case UPDATE_ORDER_ADDRESS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case CLEAR_UPDATE_ORDER_ERRORS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case CLEAR_UPDATE_ORDER_STATE:
      return {
        loading: false,
        shipInfo: null,
      };

    default:
      return state;
  }
};

export const getAllOrderListReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ORDER_LIST_REQUEST:
      return {
        loading: true,
        orderList: {},
      };
    case GET_ORDER_LIST_SUCCESS:
      return {
        loading: false,
        orderList: action.payload,
      };
    case GET_ORDER_LIST_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case CLEAR_ORDER_ERRORS:
      return {
        orderList: {},
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export const getOrderInvoiceReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ORDER_INVOICE_REQUEST:
      return {
        loading: true,
        invoiceDetails: {},
      };
    case GET_ORDER_INVOICE_SUCCESS:
      return {
        loading: false,
        invoiceDetails: action.payload,
      };
    case GET_ORDER_INVOICE_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case CLEAR_INVOICE_DOWNLOAD_ERRORS:
      return {
        invoiceDetails: {},
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};
